/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { isMobile } from 'react-device-detect';
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Checkbox, Form, Input, message } from 'antd';
import Button from '../../components/Button';
import { actions } from "../../store/reducers/authentication";
import AuthLayout from "../Layout/AuthLayout";
import { TermsAggreed } from "../../screens/Register";
import Redirect from "../Redirect";

const mstp = ({ authentication }) => ({ authentication });
const step = 1;

const Invitation = ({
  authentication: { errors, user, invitationSuccess, loggingIn },
  confirmInvitation,
  getUserFromInvitation
}) => {
  const { t } = useTranslation();
  const { app, companyCode, userCode } = useParams();
  const [passwords] = Form.useForm();
  const [checking, setChecking] = useState(true);
  const goTo = useNavigate();
  const [termsAgreed, setTermsAgreed] = useState(false);
  const [passwordReseted, setPasswordReseted] = useState(false)

  useEffect(() => {
    if (companyCode && userCode) {
      getUserFromInvitation({ companyCode, userCode }, () => {
        setChecking(false)
      });
    }
  }, [])

  useEffect(() => {
    if (invitationSuccess && user && user.inviteToken) {
      confirmInvitation(
        {},
        (data) => {
          if (data.token) {
            localStorage.setItem('token', data.token);
          }
          message.success(t('Invitation accepted'));
          goTo('/');
        },
        { companyCode, userCode }
      );
    }
  }, [invitationSuccess]);

  const displayError = (name) => {
    return errors && errors[name] && errors[name].length > 0 && {
      help: errors[name][0],
      validateStatus: 'error',
    }
  }

  const subTitle = !passwordReseted ? 'Set up your password and agree with out terms and conditions.' :
    isMobile ? 'Your account has been successfully set up. To log in use a desktop device.'
      : 'Your account has been successfully set up. Please click the button below to log in.';
  const title = passwordReseted ? 'Thank You!' : undefined;

  // const userName = user && user.firstName ? user.firstName : '';

  return checking && !invitationSuccess ?
    <div className="loaderizer">
      <div className="inner one"></div>
      <div className="inner two"></div>
      <div className="inner three"></div>
    </div>
    : (invitationSuccess && !user.inviteToken ? (
      <AuthLayout app={app} step={step} subTitle={subTitle} title={title}>
        {passwordReseted ? (
          <div>
            {isMobile ? null : (
              <Button
                type="primary"
                className="normal-br"
                onClick={() => {
                  window.location.href = '/login'
                }}
              >
                {t('Log In')}
              </Button>
            )}
          </div>
        ) : (
          <>
            <Form name="password" layout="vertical" form={passwords} >
              <Form.Item
                required
                name="password"
                {...displayError('password')}
                label={t("Password")}
                // hasFeedback
                rules={[{
                  required: true,
                  message: t("errors::password should not be empty")
                }]}>
                <Input.Password size="large" placeholder={t("Password")} />
              </Form.Item>
              <Form.Item
                required
                name="confirmPassword"
                {...displayError('confirmPassword')}
                label={t("Confirm Password")}
                // hasFeedback
                dependencies={['password']}
                rules={[
                  {
                    required: true,
                    message: t("errors::password should not be empty"),
                  },
                  ({ getFieldValue }) => ({
                    validator(rule, value) {
                      if (!value || getFieldValue('password') === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(t('errors::passwordNotMatch'));
                    },
                  }),
                ]}>
                <Input.Password size="large" placeholder={t("Confirm Password")} />
              </Form.Item>
              <Form.Item
                name="mailUpdates" valuePropName="checked" noStyle>
                <Checkbox>{t("Sign up to receive updates")}</Checkbox>
              </Form.Item>
              <Form.Item
                name="agreeTerms" valuePropName="checked" noStyle>
                <TermsAggreed
                  termsAgreed={termsAgreed}
                  setTermsAgreed={setTermsAgreed}
                  t={t}
                />
              </Form.Item>
            </Form>
            <div className="buttons">
              <Button
                className="normal-br"
                type="primary"
                block
                size="large"
                disabled={!termsAgreed}
                onClick={() => {
                  passwords.validateFields().then(data => {
                    const { password, mailUpdates } = data;
                    confirmInvitation(
                      { password, mailUpdates },
                      () => { },
                      { companyCode, userCode }
                    );
                    setPasswordReseted(true);
                    // window.location.href = '/';
                  })
                }}
              >
                {t("Confirm")}
              </Button>
            </div>
          </>
        )}
      </AuthLayout>
    ) : user ? <Redirect path="/app/pme" /> : <Redirect path="/" />)
};

export default connect(mstp, actions)(Invitation);
